import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  productDetailInfo: {},
};

const productDetailSlice = createSlice({
  name: "productDetail",
  initialState: initialState,
  reducers: {
    setProductDetailInfo(state, action) {
      state.productDetailInfo = action.payload;
    },
  },
});

export const { setProductDetailInfo } = productDetailSlice.actions;
export default productDetailSlice.reducer;
